import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
 
import langEn from './en/translation.json';
import langKo from './ko/translation.json';
import langth from './th/translation.json';
import langVn from './vn/translation.json';

 
const resource = {
    en: {
        translation: langEn
    },
    ko: {
        translation: langKo
    },
    th: {
        translation: langth
    },
    vn: {
        translation: langVn
    }
}
 
i18n
    .use(initReactI18next)
    .init({
        resources: resource,
        // 초기 설정 언어
        lng: localStorage.getItem("language") || "ko",
        fallbackLng: 'ko',           
        interpolation: {
            escapeValue: false
        },
        react : {
            transSupportBasicHtmlNodes: true,
            transKeepBasicHtmlNodesFor: ['br', 'strong', 'i']
        }
    })
 
export default i18n;